import React from 'react'

export default function Logo(_props: {color?: string}) {
  return (
    <img
      src="https://img.alicdn.com/tfs/TB1WESIN1L2gK0jSZFmXXc7iXXa-192-77.png"
      alt="logo"
      width="99"
      height="40"
      style={{ position: 'relative', top: -2 }}
    />
  )
}
